import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ThreeDotsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 8.88889C3.825 8.88889 4.5 9.55556 4.5 10.3704C4.5 11.1852 3.825 11.8519 3 11.8519C2.175 11.8519 1.5 11.1852 1.5 10.3704C1.5 9.55556 2.175 8.88889 3 8.88889ZM3 7.40741C1.35 7.40741 0 8.74074 0 10.3704C0 12 1.35 13.3333 3 13.3333C4.65 13.3333 6 12 6 10.3704C6 8.74074 4.65 7.40741 3 7.40741ZM7.5 1.48148C8.325 1.48148 9 2.14815 9 2.96296C9 3.77778 8.325 4.44444 7.5 4.44444C6.675 4.44444 6 3.77778 6 2.96296C6 2.14815 6.675 1.48148 7.5 1.48148ZM7.5 0C5.85 0 4.5 1.33333 4.5 2.96296C4.5 4.59259 5.85 5.92593 7.5 5.92593C9.15 5.92593 10.5 4.59259 10.5 2.96296C10.5 1.33333 9.15 0 7.5 0ZM12 8.88889C12.825 8.88889 13.5 9.55556 13.5 10.3704C13.5 11.1852 12.825 11.8519 12 11.8519C11.175 11.8519 10.5 11.1852 10.5 10.3704C10.5 9.55556 11.175 8.88889 12 8.88889ZM12 7.40741C10.35 7.40741 9 8.74074 9 10.3704C9 12 10.35 13.3333 12 13.3333C13.65 13.3333 15 12 15 10.3704C15 8.74074 13.65 7.40741 12 7.40741Z"
          fill="#666666"
        />
      </svg>
    </SvgIcon>
  );
};

export default ThreeDotsIcon;
